import React from 'react';
import { Grid, Typography } from '@quillbot/design-system';

import { makeStyles } from '@mui/styles';
import createStyles from '@mui/styles/createStyles';

const useStyles = makeStyles((theme) =>
  createStyles({
    grecaptchaDeclaration: {
      // color: ' gray',
      '& a:hover': {
        textDecoration: 'underline',
      },
    },
    linkColor: {
      color: theme.palette.text.primary,
    },
  })
);

function BottomMessage() {
  const classes = useStyles();
  return (
    <Grid container>
      <Grid item>
        <Typography
          variant="caption"
          className={classes.grecaptchaDeclaration}
          color="textSecondary"
        >
          This site is protected by reCAPTCHA and the Google{' '}
          <a
            href="https://policies.google.com/privacy"
            target="_blank"
            rel="noopener noreferrer"
            className={classes.linkColor}
          >
            Privacy Policy
          </a>{' '}
          and{' '}
          <a
            href="https://policies.google.com/terms"
            target="_blank"
            rel="noopener noreferrer"
            className={classes.linkColor}
          >
            Terms of Service
          </a>{' '}
          apply.
        </Typography>
      </Grid>
    </Grid>
  );
}
export default BottomMessage;
